import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as D from '../../../deps';
import { getPodcastEpisodeProgressById } from '../../../utils';

import './BackstagePodcastEpisodeSubheaderSmall.scss';

const BackstagePodcastEpisodeSubheaderSmall = props => {
  return (
    <div className='BackstagePodcastEpisodeSubheaderSmall'>
      <D.PodcastEpisodeMetadata
        releaseDate={props.releaseDate}
        episodeDuration={props.episodeDuration}
        elapsedTime={props.elapsedTime}
        isFinished={props.isFinished}
      />
    </div>
  );
};

BackstagePodcastEpisodeSubheaderSmall.propTypes = {
  releaseDate: PropTypes.string,
  episodeDuration: PropTypes.number,
  elapsedTime: PropTypes.number,
  isFinished: PropTypes.bool,
};

export function mapStateToProps(state, ownProps) {
  const { episodeId } = ownProps;
  const episodeAnnotation = D.getAnnotationsById(state, episodeId);
  const progressDetails = getPodcastEpisodeProgressById(state, episodeId);

  return {
    releaseDate: D.Utils.Core.getFromMap(episodeAnnotation, 'releaseDate'),
    episodeDuration: D.Utils.Core.getFromMap(episodeAnnotation, 'duration'),
    elapsedTime: D.Utils.Core.getFromMap(progressDetails, 'elapsedTime'),
    isFinished: D.Utils.Core.getFromMap(progressDetails, 'isFinished'),
  };
}

export default connect(mapStateToProps)(BackstagePodcastEpisodeSubheaderSmall);
